// extracted by mini-css-extract-plugin
export default {"arrowIcon":"MenuModuleButton_arrowIcon__hly6U","button":"MenuModuleButton_button__HIPh5"};